﻿"use strict";

angular.module('app.financeiro').factory('retornoPagamentoBancoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'RetornoPagamentoBanco';

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _list = function (search, options, dataInicio, dataTermino) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _listDetalhesPorSeuNumero = function (search, options, codigo, situacao) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoRetorno", "value": codigo });
        dto.parms.push({ "name": "Situacao", "value": situacao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListDetalhesPorSeuNumero', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.list = _list;
    factory.findRecord = _findRecord;
    factory.listDetalhesPorSeuNumero = _listDetalhesPorSeuNumero;

    return factory;

}]);
